import { Fragment } from "react";
import { Icon } from "@theorgchartdev/storybook";

const BigOptionContent = ({ label, description, icon, iconSize = "medium", dataTestId }) => {
  const baseElemContainerClass = "ocn-edit-menu-container";
  const baseElemTextClass = "ocn-edit-menu-text";

  return (
    <Fragment>
      <span className={baseElemContainerClass}>
        <span className={`${baseElemContainerClass}-icon`}>
          {icon && <Icon name={icon} size={iconSize} />}
        </span>
        <span className={`${baseElemTextClass}`} data-testid={dataTestId}>
          <span className={`${baseElemTextClass}-label`}>{label}</span>
          <span className={`${baseElemTextClass}-description`}>{description}</span>
        </span>
      </span>
    </Fragment>
  );
};

export default BigOptionContent;
